import {
    Box, Card,
    FormControl,
    Grid,
    InputLabel,
    Modal,
    Select,
    Typography
} from '@mui/material';
import MDButton from 'components/MDButton';

// import { colorScheme } from 'default';
import Map from 'components/Map/map';
import { useMaterialUIController } from "context";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    display: 'grid',
    justifyContent: 'center'
};
function InvoiceModal({ ...props }) {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 350,
                overflowY: 'scroll',
            },
        },
    };
    return (
        <Modal
            open={props.open}
            onClose={props.closeModalClick}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Card sx={style} className={darkMode ? "darkPopup" : "whitePopup"}>
                <Box>
                    <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
                        <MDButton onClick={props.handleAdd} style={{ width: "64px", textTransform: "capitalize", backgroundColor: "#87CEEB", color: "white" }}>
                            Add
                        </MDButton>
                    </Grid>

                    <Typography id="modal-modal-title" variant="h6" component="h2" className={darkMode ? "darkPopup" : "whitePopup"} mt={2}>
                        Choose any one theme
                    </Typography>
                    <Grid item lg={12} xs={12} mt={1}>
                        <FormControl fullWidth >
                            <InputLabel id="demo-simple-select">Select Theme</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Select Theme"
                                style={{ minHeight: "3em" }}
                                value={props.value}
                                onChange={props.onChange}
                                MenuProps={MenuProps}
                            >
                                {props.menuData}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
                        <MDButton color="warning" onClick={props.handleCancel} style={{ width: "64px", textTransform: "capitalize" }}>
                            Cancel
                        </MDButton>
                        &nbsp; &nbsp;
                        <MDButton color="success" onClick={props.handleSave} style={{ width: "64px", textTransform: "capitalize" }}>
                            Proceed
                        </MDButton>
                        <Map />
                    </Grid>
                </Box>
            </Card>
        </Modal>

    );
}

export default InvoiceModal;
